export default __webpack_public_path__ + "src/appV2/redesign/TravelShifts/assets/images/travelSuitcase.png";